import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Tabs, 
  Tab, 
  Alert
} from '@mui/material';
import { useAuth } from '../../../contexts/AuthContext.js';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import SecurityIcon from '@mui/icons-material/Security';

// Import the tab components
import UserAdmin from './UserAdmin';
import DivesiteAdmin from './DivesiteAdmin';
import ClaimAdmin from './ClaimAdmin';

const Admin = () => {
  const { userClaims } = useAuth();
  const [tabValue, setTabValue] = useState(0);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Check if user has admin access
  useEffect(() => {
    if (!userClaims || !userClaims.isAdmin) {
      setError("You do not have permission to access this page.");
    }
  }, [userClaims]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // If user is not an admin, show access denied message
  if (!userClaims || !userClaims.isAdmin) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h4" color="error">
          Access Denied
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          You do not have permission to access the admin console.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        <AdminPanelSettingsIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
        Admin Console
      </Typography>
      
      <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 3 }}>
        <Tab icon={<PersonIcon />} label="User Management in Mongo DB" />
        <Tab icon={<LocationOnIcon />} label="Divesite Management" />
        <Tab icon={<SecurityIcon />} label="Claim Management in Firebase DB" />
      </Tabs>
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }} onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {success && (
        <Alert severity="success" sx={{ mb: 3 }} onClose={() => setSuccess(null)}>
          {success}
        </Alert>
      )}
      
      {/* Render the appropriate tab component based on tabValue */}
      {tabValue === 0 && <UserAdmin setError={setError} setSuccess={setSuccess} />}
      {tabValue === 1 && <DivesiteAdmin setError={setError} setSuccess={setSuccess} />}
      {tabValue === 2 && <ClaimAdmin setError={setError} setSuccess={setSuccess} />}
    </Box>
  );
};

export default Admin;
